module.exports = __webpack_public_path__ + "static/media/next.5fea6c27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Pair/scenes/Addresses/img/next.svg
// module id = 175
// module chunks = 0